<template>
  <div v-if="filterValues" class="filters box">
    <div class="panel">
      <div class="panel-header">
        <h3><i class="fa fa-filter"></i> Filters</h3>
      </div>
      <div class="panel-body">
        <div class="filters-buttons">
          <button type="button" @click="applyFilters" :disabled="!applyPending" class="btn btn-block btn-primary"><i class="fa fa-filter"></i>&nbsp;Apply</button>
          <button type="button" @click="resetFilters" :disabled="resetDisabled" class="btn btn-block btn-default"><i class="fa fa-trash"></i>&nbsp;Clear all</button>
        </div>
        <div class="filters-widgets">
          <template v-for="(filter_def, filter_name) in filters">
            <FormulateInput v-if="filter_def.type == 'string'" type="text" v-model="filterValues[filter_name]" :key="filter_name" :label="filter_def.label">
              <template #label="{ label, id }">
                <div class="label-wrapper">
                  <label class="formulate-input-label formulate-input-label--before" :for="id">
                    {{ label }}
                  </label>
                  <a class="text-right reset-filter" role="button" @click="resetFilter(filter_name)"><i class="fa fa-trash"></i></a>
                </div>
              </template>
            </FormulateInput>
            <FormulateInput v-else-if="filter_def.type == 'choice' && !filter_def.many" type="select" v-model="filterValues[filter_name]" :options="options[filter_name]" :label="filter_def.label">
              <template #label="{ label, id }">
                <div class="label-wrapper">
                  <label class="formulate-input-label formulate-input-label--before" :for="id">
                    {{ label }}
                  </label>
                  <a class="text-right reset-filter" role="button" @click="resetFilter(filter_name)"><i class="fa fa-trash"></i></a>
                </div>
              </template>
            </FormulateInput>
            <FormulateInput v-else-if="filter_def.type == 'choice' && filter_def.many"
              type="select"
              v-model="filterValues[filter_name]"
              :options="options[filter_name]"
              :label="filter_def.label" multiple="true"
              :element-class="['select--multiple']">
              <template #label="{ label, id }">
                <div class="label-wrapper">
                  <label class="formulate-input-label formulate-input-label--before" :for="id">
                    {{ label }}
                  </label>
                  <a class="text-right reset-filter" role="button" @click="resetFilter(filter_name)"><i class="fa fa-trash"></i></a>
                </div>
              </template>
            </FormulateInput>
            <FormulateInput v-else-if="filter_def.type == 'search' && renderSearch" type="search" v-model="filterValues[filter_name]" :placeholder="filter_def.label"></FormulateInput>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    name: 'filters',
    components: {
    },
    props: {
      filters: Object,
      renderSearch: {
        type: Boolean,
        default: false
      },
    },
    data () {
      return {
        filterValues: null,
        options: null,
        applyPending: false,
      }
    },
    computed: {
      computedFilters() {
        if (this.filterValues === null) {
          return {};
        }
        return Object.fromEntries(
          Object.entries(this.filterValues).filter(([key, value]) => value.length)
        )
      },
      resetDisabled() {
        return Object.keys(this.computedFilters).length === 0;
      }
    },
    watch: {
      filters(newValue, oldValue) {
        let filterValues = {};
        let options = {}
        for (const [key, value] of Object.entries(newValue)) {
          this.resetFilter(key, filterValues);
          if (value.type == 'choice') {
            if (value.choices !== undefined) {
              options[key] = value.choices.map((option) => {
                return {value: option[0], label: option[1]};
              });
            } else {
              options[key] = [];
            }
          }
        }
        this.options = options;
        this.filterValues = filterValues;
      },
      computedFilters: {
        deep: true,
        handler: function(newValue, oldValue) {
          if(Object.keys(newValue).length > 0 ||
             Object.keys(oldValue).length > 0) {
            this.applyPending = true;
          }
        }
      }
    },
    methods: {
      applyFilters() {
        this.applyPending = false;
        this.$emit('applyFilters', this.computedFilters);
      },
      resetFilters() {
        for (const key of Object.keys(this.filters)) {
          this.resetFilter(key, this.filterValues);
        }
      },
      resetFilter(filterName, filterValues) {
        if (filterValues === undefined) {
          filterValues = this.filterValues;
        }

        let filterDef = this.filters[filterName];
        if (filterDef.type == 'choice') {
          if(filterDef.many !== undefined && filterDef.many) {
            filterValues[filterName] = [];
          }
          else {
            filterValues[filterName] = '';
          }
        }
        else {
          filterValues[filterName] = '';
        }
      }
    }
  }
</script>
<style lang="scss">
  .filters {
    display: flex;
    flex-direction: column;
    position: fixed;
    margin-right: 1rem;
    max-height: 95vh;

    .panel {
      height: 100%;
      overflow-y: auto;
    }

    .filters-buttons {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      gap: .5rem .5rem;
      padding: .5rem;

    }

    .filters-widgets {
      display: flex;
      flex-direction: column;
      justify-content: center;
      padding: .5rem;
      gap: .5rem;

      .formulate-input .label-wrapper {
        display: flex;
        justify-content: space-between;

        a.reset-filter {
          color: #666;
        }
      }

      .formulate-input[data-classification="select"] select,
      .formulate-input[data-classification="text"] input {
        background-color: white;
        color: #333;
      }

      .select--multiple::before {
        display: none;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// Filters.vue?78cb0bde